import { Check, X, CalendarClock, BadgeCheck, PauseCircle } from "lucide-react";

export default function VipRules({ rules, paused }) {
  if (!rules) return null;
  return (
    <section data-testid="vip-rules" className="grid md:grid-cols-2 gap-4">
      <div className="card-surface p-5 border border-white/8">
        <div className="text-[10px] uppercase tracking-[0.3em] text-emerald-400 mb-3">What counts</div>
        <ul className="space-y-2 text-sm text-zinc-300">
          {rules.counts.map((r) => <li key={r} className="flex gap-2"><Check size={15} className="text-emerald-400 shrink-0 mt-0.5" /> {r}</li>)}
        </ul>
      </div>
      <div className="card-surface p-5 border border-white/8">
        <div className="text-[10px] uppercase tracking-[0.3em] text-rose-400 mb-3">What never counts</div>
        <ul className="space-y-2 text-sm text-zinc-300">
          {rules.excluded.map((r) => <li key={r} className="flex gap-2"><X size={15} className="text-rose-400 shrink-0 mt-0.5" /> {r}</li>)}
        </ul>
      </div>
      <div className="card-surface p-5 border border-white/8 flex gap-3">
        <CalendarClock size={18} className="text-amber-300 shrink-0 mt-0.5" />
        <div><div className="text-sm text-white font-medium">Monthly reset</div><p className="text-sm text-zinc-400 mt-1" data-testid="vip-rule-reset">{rules.reset}</p></div>
      </div>
      <div className="card-surface p-5 border border-white/8 flex gap-3">
        <BadgeCheck size={18} className="text-sky-300 shrink-0 mt-0.5" />
        <div><div className="text-sm text-white font-medium">Automatic awards</div><p className="text-sm text-zinc-400 mt-1" data-testid="vip-rule-awards">{rules.awards}</p></div>
      </div>
      {paused?.length > 0 && (
        <div data-testid="vip-paused-notice" className="md:col-span-2 border border-white/10 bg-white/[0.02] p-5 flex gap-3">
          <PauseCircle size={18} className="text-zinc-500 shrink-0 mt-0.5" />
          <div>
            <div className="text-sm text-zinc-300 font-medium">Paused &amp; hidden — not active</div>
            <p className="text-sm text-zinc-500 mt-1">These badges are currently switched off and are not shown anywhere in the app:</p>
            <div className="flex flex-wrap gap-2 mt-3">
              {paused.map((p) => <span key={p.key} data-testid={`vip-paused-${p.key}`} className="text-[10px] uppercase tracking-widest border border-white/10 text-zinc-500 px-2 py-1 line-through decoration-zinc-600">{p.label}</span>)}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
